import type {
    SpendActivationProgress,
    SpendActivationTaskNames,
} from './bff/spend-activation-progress.bff'

import {bffHooks} from '../../bff-hooks'

const defaultValue: SpendActivationProgress = {
    allCompleted: false,
    percent: 0,
    tasks: {
        createVendorCards: {completed: false},
        configureSubWallets: {completed: false},
        activateVendorCards: {completed: false},
    },
}

const useSpendActivationGuideProgress = (
    {
        enabled,
    }: {
        enabled: boolean
    } = {enabled: true},
): {
    isLoading: boolean
    progress: SpendActivationProgress
    completeTask: (name: SpendActivationTaskNames) => Promise<SpendActivationTaskNames>
} => {
    const {data = defaultValue, isLoading} =
        bffHooks.recurringVendors.spendActivationGuide.getSpendActivationProgress.useQuery(
            undefined,
            {
                enabled,
            },
        )

    return {
        isLoading,
        progress: data,
        // Placeholder for once the backend is complete and mutations can be added
        completeTask: async (name) => name,
    }
}

export default useSpendActivationGuideProgress
